module.exports = __webpack_public_path__ + "static/img/day5.9609f8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour5/day5.jpg
// module id = j1AD
// module chunks = 0